/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc
 */

export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const getListingDetailsV1Rpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'getListingDetailsV1',
  auth: 'app',
  fingerprint: 'r43xwBRJCLJBJlw6H8yN7ka-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getListingDetailsV2Rpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'getListingDetailsV2',
  auth: 'app',
  fingerprint: 'XXty8CSBgCBFlkikHog9NUa-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getListingDetailsV3Rpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'getListingDetailsV3',
  auth: 'app',
  fingerprint: 'fDfyt5YhKRbIzE6AOuEHW0a-r6BPox_M',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};